<main-create-post (postInput)="createGroupPost($event)"></main-create-post>
